import dayjs from 'dayjs';

const MINUTE = 60 * 1000;

export const STATUS_META = {
  ON_MOVING: {
    key: 'ON_MOVING',
    label: 'Em movimento',
    uiColor: '#28A745',
    mapColor: 'success',
  },
  OFF: {
    key: 'OFF',
    label: 'Ignição desligada',
    uiColor: '#DC3545',
    mapColor: 'error',
  },
  ON_STOPPED: {
    key: 'ON_STOPPED',
    label: 'Parado c/ motor ligado',
    uiColor: '#FFC107',
    mapColor: 'warning',
  },
  IDLE_10M: {
    key: 'IDLE_10M',
    label: 'Ocioso > 10 min',
    uiColor: '#FD7E14',
    mapColor: 'warningDark',
  },
  OUT_24H: {
    key: 'OUT_24H',
    label: 'Desconectado > 24h',
    uiColor: '#0B3D91',
    mapColor: 'infoDark',
  },
  OUT_12H: {
    key: 'OUT_12H',
    label: 'Desconectado > 12h',
    uiColor: '#007BFF',
    mapColor: 'info',
  },
  OUT_72H: {
    key: 'OUT_72H',
    label: 'Desconectado > 72h',
    uiColor: '#6F42C1',
    mapColor: 'purple',
  },
  NO_DATA: {
    key: 'NO_DATA',
    label: 'Sem dados',
    uiColor: '#6C757D',
    mapColor: 'neutral',
  },
};

export const toKph = (knots) => {
  if (knots == null) return null;
  const n = Number(knots);
  if (Number.isNaN(n)) return null;
  return n * 1.852;
};

export const getPositionTimeMs = (position) => {
  const raw = position?.fixTime
    ?? position?.deviceTime
    ?? position?.serverTime
    ?? position?.time
    ?? position?.timestamp;

  const t = raw ? new Date(raw).getTime() : NaN;
  return Number.isFinite(t) ? t : null;
};

export const getOperationalStatusKey = (device, position) => {
  const lastUpdate = position?.fixTime
    || position?.deviceTime
    || position?.serverTime
    || position?.time
    || position?.timestamp
    || device?.lastUpdate;

  if (!lastUpdate) {
    return 'NO_DATA';
  }

  const hours = dayjs().diff(dayjs(lastUpdate), 'hour');

  if (hours >= 72) {
    return 'OUT_72H';
  }

  if (hours >= 24) {
    return 'OUT_24H';
  }

  if (hours >= 12) {
    return 'OUT_12H';
  }

  const ignition = position?.attributes?.ignition ?? null;
  const speedKph = toKph(position?.speed);
  const moving = speedKph != null && speedKph > 2;

  const posTime = getPositionTimeMs(position);
  const ageMs = posTime ? (Date.now() - posTime) : null;
  const idle10m = ignition === true && !moving && ageMs != null && ageMs >= 10 * MINUTE;

  if (ignition === false) {
    return 'OFF';
  }

  if (moving) {
    return 'ON_MOVING';
  }

  if (idle10m) {
    return 'IDLE_10M';
  }

  if (ignition === true) {
    return 'ON_STOPPED';
  }

  return 'NO_DATA';
};

export const getOperationalStatusMeta = (device, position) => {
  const key = getOperationalStatusKey(device, position);
  return STATUS_META[key] || STATUS_META.NO_DATA;
};
